import { render, staticRenderFns } from "./PeriodNavigation.vue?vue&type=template&id=5af94346&scoped=true"
import script from "./PeriodNavigation.vue?vue&type=script&lang=js"
export * from "./PeriodNavigation.vue?vue&type=script&lang=js"
import style0 from "./PeriodNavigation.vue?vue&type=style&index=0&id=5af94346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af94346",
  null
  
)

export default component.exports